import { Link } from "react-router-dom";
import bgImg from "../../images/top_footer.png"; 



const TopFooter = ({ topfootHead, topfootPara, bookCall }) => {
  return (
    <div className="row">
      <div className="topfooter" style={{ backgroundImage: `url(${bgImg})` }}>
        <div className="container">
          <h4>{topfootHead}</h4>
          <div className="row">
            <div className="col-md-8">
              <p>{topfootPara}</p>
            </div>
            <div className="col-md-4 text-center">
              <Link to="/contact" className="bookcall">{bookCall} </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
};


export default TopFooter;



